module.exports = __webpack_public_path__ + "img/top-right-background.2c8305d7.svg";